import { INotification, INotificationDetail } from '@/types'
import { create } from 'zustand'
import { notificationService } from '../services'
import { axiosErrorMessage, mountStoreDevtool } from '../utils'

interface NotificationStore {
  notificationDetails: INotificationDetail[]
  error: Error | null
  loading: boolean
  notifications: INotification[]
  activeTab: number
  setActiveTab: (tab: number) => void
  setNotifications: (notifications: INotification[]) => void
  init: () => Promise<void>
  incoming: (notification: INotification) => Promise<void>
  decrement: (group: INotificationDetail['group']) => void
}

export const useNotificationStore = create<NotificationStore>((set, get) => ({
  notificationDetails: [],
  notifications: [],
  activeTab: 0,
  error: null,
  loading: true,

  init: async () => {
    try {
      set({ error: null, loading: true })
      const notificationDetails = await notificationService.getDetailNotifications()
      set({ notificationDetails, loading: false })
    } catch (e) {
      set({ error: axiosErrorMessage(e), loading: false })
    }
  },

  incoming: async (notification) => {
    const { activeTab, notifications } = get()
    const notificationDetails = await notificationService.getDetailNotifications()

    const active = notificationDetails[activeTab]

    let newNotifications = [...notifications]
    if (active?.group === notification.group) {
      newNotifications = [notification, ...notifications]
    }

    set({ notificationDetails, notifications: newNotifications })
  },

  setNotifications(notifications) {
    set({ notifications })
  },

  setActiveTab(tab) {
    set({ activeTab: tab })
  },

  decrement(group: string) {
    const { notificationDetails } = get()

    const newNotificationDetails = notificationDetails.map((detail) => {
      if (detail.group === group) {
        const newUnreadCount = Math.max(detail.unreadCount - 1, 0)
        return { ...detail, unreadCount: newUnreadCount }
      }
      return detail
    })

    set({ notificationDetails: newNotificationDetails })
  },
}))

if (import.meta.env.DEV) {
  mountStoreDevtool('notification.store', useNotificationStore)
}
